import { createStore, useStore } from "zustand";
import { immer } from "zustand/middleware/immer";
import { ImmerGet, ImmerSet } from "..";
import { createContext, useContext } from "react";
import { ElementMotionState } from "./element-motion-state";
import { ElementMotionService } from "./element-motion-service";

export type Set = ImmerSet<ElementMotionState>;
export type Get = ImmerGet<ElementMotionState>;

export const createElementMotionStore = () => {
  return createStore<ElementMotionState>()(
    immer<ElementMotionState>((set, get) => ({
      reactivePointerState: null,
      boundingBoxes: {},
      movingElements: {},
      selectedElementIds: new Set(),
      marqueeBoundingBox: null,
      service: new ElementMotionService(set, get),
    })),
  );
};

export const ElementMotionStoreContext = createContext<ReturnType<
  typeof createElementMotionStore
> | null>(null);

export function useElementMotionStore<U>(
  selector: (state: ElementMotionState) => U,
) {
  const store = useContext(ElementMotionStoreContext);

  if (store === null) {
    throw new Error(
      "useElementMotionStore must be used within ElementMotionStoreProvider",
    );
  }

  return useStore(store, selector);
}
